import BaseEntity from 'src/entities/BaseEntity';
import { EntityDescriptions } from 'src/store/entities/types';
import EntityDescription from 'src/store/entities/types/EntityDescription';

interface Address {
    addresseeName: string;
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
    countryIso2: string;
}

export default class Representative extends BaseEntity {
    public representativeName: string;
    public shortDescription: string;
    public address: Address;
    public officeTimes: string;
    public description: string;
    public images: string[];

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(json: any) {
        super(json);

        this.representativeName = json.representativeName;
        this.shortDescription = json.shortDescription;
        this.address = {
            addresseeName: json.address.addresseeName,
            street: json.address.street,
            streetNumber: json.address.streetNumber,
            postalCode: json.address.postalCode,
            city: json.address.city,
            countryIso2: json.address.countryIso2,
        };
        this.officeTimes = json.officeTimes;
        this.description = json.description;
        this.images = json.images;
    }

    getEntityDescription(): EntityDescription {
        return EntityDescriptions.REPRESENTATIVE;
    }

    toString(): string {
        return this.representativeName;
    }
}
